export enum CustomerDashboardTab {
  BILLING_TOTALS = 'billingTotals',
  ABANDONED_PAY_APPS = 'abandonedPayApps',
  FEATURE_USAGE = 'featureUsage',
  FORM_TRACKER = 'formTracker',
  TIME_TO_VALUE = 'timeToValue',
}
